export default "__VITE_ASSET__CxGSYoLY__"